import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { AppContext } from '../ContextApi/ContextApi';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import "./jobs.css";
import Swal from 'sweetalert2';
import { basePath, currentDateAndTime, formatDate, validateNumber, validateFile, isObject, daysDifference } from '../Constants/constant';
import { IoMdAddCircleOutline } from "react-icons/io";
import PageBanner from '../Usables/PageBanner';
import RefreshButton from '../Usables/RefreshButton';
import BasicButton, { FollowupButton, HistoryButton } from '../Usables/Buttons';
import Dropdown from '../Usables/Dropdown';
import Loader from '../Usables/Loader';
import Pagination from '../Usables/Pagination';
import NoRecords from '../Usables/NoRecords';
import InputField from '../Usables/InputField';
import { UpDownArrow } from '../Usables/IconButtons';
import JobPost from './JobPost';
import FollowUp from '../Usables/FollowUp';
import PositionFollowUpHistory from './FollowUpLogs';
import TooltipComponent from '../Usables/TooltipComponent';
import { IoAdd } from "react-icons/io5";
import RecruiterAssigning from '../Usables/RecruiterAssigning';
import RecruiterWiseData from '../Usables/RecruiterWiseData';

function AllPostedJobs(props) {
    const { index } = useParams();
    const { setIsModalOpen, user, apiHeaderJSON, apiHeaderFile } = useContext(AppContext);
    const navigate = useNavigate();
    const [allJobs, setAllJobs] = useState([]);
    const [allUsers, setAllUsers] = useState([]);
    const [jobFormModal, setJobFormModal] = useState(false);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(true);
    const [loadingFilter, setLoadingFilter] = useState(false);
    const [jobEdit, setJobEdit] = useState(false);
    const [extraQuestions, setExtraQuestions] = useState([]);
    const [formData, setFormData] = useState({});
    const [recruiterWiseData, setRecruiterWiseData] = useState([]);
    const [followupData, setFollowupData] = useState({});
    const [followupModal, setFollowupModal] = useState(false);
    const [viewFollowUpLogs, setViewFollowUpLogs] = useState(false);
    const [atsIndex, setAtsIndex] = useState(false);
    const [recruiterModal, setRecruiterModal] = useState(false);
    const [recruiterWiseView, setRecruiterWiseView] = useState(false);
    const [usersOption, setUsersOption] = useState([{value: "Only Assigned", label: "Assigned"},{value: "Not Assigned", label: "Not Assigned"},]);
    const [filterData, setFilterData] = useState({
        fromDate: "",
        toDate: "",
        company: "",
        position: "",
        positionStatus: "Open",
        // recruiter: localStorage.getItem("role") === "Recruiter" || localStorage.getItem("role") === "Team Lead" ? localStorage.getItem("userId") : "",
        orderBy: "",
        orderDirection: "",
        // orderBy: "upload_date",
        // orderDirection: "DESC",
        isActive:true,
    });
    const [pagination, setPagination] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});
    const [paginationRecruiterWiseList, setPaginationRecruiterWiseList] = useState({page: 1, totalRecords: "", totalPages: "", limit: 10,});
    const [recruiterReportFilter, setRecruiterReportFilter] = useState({
        recruiterStatus: 1,
        isActive: true,
        orderBy: "assigned_at",
        orderDirection: "DESC"
    });
    const [ischanged, setIschanged] = useState({
        getListChanged: false,
    });
    const jobStatusOptions = [
        { value: "All", label:"All"},
        { value: "Open", label:"Open"},
        { value: "Close", label:"Close"},
        { value: "On Hold", label:"On Hold"},
    ];

    const handleAssignDate = useCallback((e)=> {
        const {id} = e.target;
        setFormData({...formData, assign_date: id });
    },[formData]);

    useEffect(()=>{
        user?.filter((val, idx) => {
            if (val?.Module?.module_name === "ATS Pipeline") {
                setAtsIndex(idx);
                return val;
            }
        });
    },[user]);

    const getUserData = async () => {
        try {
             let options = {
                headers:apiHeaderJSON
            }
            const response = await axios.get(`${basePath}/getRecruiter`, options);
            // console.log("users====>>>>>", response.data);
            const recruiterList = response?.data?.map((val)=>{
            return {value: val?.id, label: val?.name, activated: val?.activated}
            });
            const listFilter = response?.data?.filter((val)=>{
                if(val?.activated === 1) return  val;
            });
            const activeList = listFilter?.map((val)=>{
                return {value: val?.id, label: val?.name, activated: val?.activated}
            });
            setAllUsers(recruiterList);
            setUsersOption([{value: "Only Assigned", label: "Assigned"},
                {value: "Not Assigned", label: "Not Assigned"}, ...activeList]);
        } catch (error) {
            toast.error("There is some server issue!!");
        }
    }

    const getList = useCallback(async () => {
        try {
            const options = {
                params: {
                    limit: pagination?.limit,
                    page: pagination?.page,
                    filter: JSON.stringify(filterData),
                },
                headers: apiHeaderJSON
            }
            const response = await axios.get(`${basePath}/getjobBypage`, options);
            // console.log("jobs==>>", response.data);
            setAllJobs(response?.data?.data);
            setPagination({
                ...pagination,
                totalPages: response?.data?.pages,
                totalRecords: response?.data?.totalRecords
            });
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            setLoading(false);
            setLoadingFilter(false);
            console.error(error);
        }
    },[apiHeaderJSON, pagination, filterData])

    useEffect(() => {
        if(ischanged?.getListChanged){
            // console.log("in getList");
            getList();
            setIschanged({ ...ischanged, getListChanged: false });
        }
    }, [ischanged]);

    async function getRecruiterWiseData() {
        try {
            const response = await axios.get(`${basePath}/getassignrecruiterlog`,{
                params:{
                    limit:paginationRecruiterWiseList?.limit,
                    page:paginationRecruiterWiseList?.page,
                    id:localStorage.getItem("userId"),
                    filter:JSON.stringify(recruiterReportFilter)
                },
                headers:apiHeaderJSON
            });
            // console.log("getRecruiterWiseData ~ res", response.data);
            setRecruiterWiseData(response.data?.data);
            setPaginationRecruiterWiseList({
                ...paginationRecruiterWiseList,
                totalPages: response?.data?.pages,
                totalRecords: response?.data?.totalRecords
            })
            setLoading(false);
            setLoadingFilter(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
            setLoadingFilter(false);
        }
    }

    useEffect(() => {
        if(ischanged?.getRecruiterWiseDataChanged){
            // console.log("in getRecruiterWiseData");
            getRecruiterWiseData();
            setIschanged({ ...ischanged, getRecruiterWiseDataChanged: false });
        }
    }, [ischanged?.getRecruiterWiseDataChanged]);

    const handleRefresh = () => {
        // console.log("loading || loadingFilter",loading, loadingFilter)
        if (!loading || !loadingFilter) {
            setLoading("1");
            getList();
        }
    }
    const handleJobSort = (columnName) => {
        if(loadingFilter) return;
        setLoadingFilter("4");
        if (filterData?.orderBy === columnName) {
            if (filterData?.orderDirection === "DESC") {
                setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'ASC' });
            }
            else {
                setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'DESC' });
            }
        }
        else {
            setFilterData({ ...filterData, orderBy: columnName, orderDirection: 'ASC' });
        }
        setIschanged({ ...ischanged, getListChanged: true });
    }
    const handlePositionStatus = async (e, row) => {
        const {value} = e.target;
        Swal.fire({
        title: 'Are you sure?',
        text: `You want to change status to ${value}!`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Change!',
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30', 
        cancelButtonColor: '#F44336',
        allowOutsideClick:false,
        input: 'textarea',
        inputLabel: 'Reason (required)',
        inputPlaceholder: 'Enter reason for revert...',
        inputAttributes: {'aria-label': 'Enter Reason',},
        preConfirm: (remark) => {
            if (!remark || remark.trim() === '') {
            Swal.showValidationMessage('Reason is required');
            return false;
            }
            return remark;
        }}).then((result) => {
            if (result.isConfirmed) {
            const data = {
                remarks: result.value,
                position_status: value
            }
            const options = {
                headers: {...apiHeaderJSON},
            }
            axios.patch(`${basePath}/updatePositionStatus/${row?.id}`, data, options)
                .then((response) => {
                    if (response.status === 200) {
                        // console.log(response);
                        getList();
                        toast.success("Position Status Changed Successfully");
                    }
                    else {
                        toast.error("Unable to Change Position Status");
                    }
                })
                .catch((e) => {
                    console.error(e);
                    toast.error("Unable to Change Position Status");
                });
        }})
    }

    const handleAssign = (val)=> {
        const all = allUsers?.filter((val)=>{if(val?.activated === 1) return val;});
        setUsersOption([{value: "Only Assigned", label: "Assigned"},
            {value: "Not Assigned", label: "Not Assigned"}, ...all]);
        setRecruiterModal(true);
        setFormData({assign_date: "1", position_id: val?.id,});
    }

    const handleDeleteRecruiter = async (val) => {
        Swal.fire({
        title: 'Are you sure?',
        text: `Are you sure to remove "${val?.User?.name}" from "${val?.position}" position?`,
        icon: 'warning',
        input: 'textarea',
        inputPlaceholder: 'Enter remark...',
        inputAttributes: {'aria-label': 'Enter Remark',},
        showCancelButton: true,
        confirmButtonText: 'Yes, Remove!',
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30',
        cancelButtonColor: '#F44336',
        allowOutsideClick: false,
        }).then(async(result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Please wait...',
                    html: 'Removing recruiter...',
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
                try {
                    const data = {
                        recruiter_id: val?.recruiter_id,
                        position_id: val?.id,
                        user_id: localStorage.getItem("userId"),
                        remarks: result.value || ""
                    }
                    const options = {
                        headers: apiHeaderJSON,
                        data
                    }
                    const response = await axios.delete(`${basePath}/deleteassingrecruiter`, options);
                    if (response.status === 200) {
                        // console.log(response);
                        toast.success(response?.data?.message || "Recruiter Removed Successfully");
                        getList();
                    }
                    else {
                        toast.error(response?.data?.message || "Unable to Remove!!");
                    }
                    Swal.close();
                } catch(e) {
                    console.log(e);
                    Swal.close();
                    toast.error(e.response?.data?.message || "Internal Server Issue!!");
                }
            }
        });
    }
    const handleRecruiter = async (e, position) => {
        const errorList = validateFormAssignRecruiter();
        console.log("errorList 1", errorList);
        if (Object.keys(errorList).length > 0) {
            setErrors(errorList);
            return;
        }
        try {
            setLoading("3");
            const data = {
                ...formData,
                user_id: localStorage.getItem("userId"),
                
            }
            // console.log("handleRecruiter ~ data", data);
            const options = {headers: apiHeaderJSON,}
            const response =  await axios.post(`${basePath}/assignRecruiter`,data,options)
            if (response.status === 200) {
                console.log(response);
                getList();
                handleClose()
                toast.success(response?.data?.message || "Recruiter Assign Successfully");
            }
            else {
                toast.error(response?.data?.message);
            }
            setLoading(false);
        } catch(e) {
            setLoading(false);
            console.log(e);
            toast.error(e.response?.data?.message || "Internal server issue!!");
        };
    }
    const handleExport = async () => {
        try {
            setLoadingFilter("3");
            const response = await axios.get(`${basePath}/exportAssignRecruiter`, {
                responseType: 'blob', // Ensure response is treated as a blob
                headers:apiHeaderJSON,
                params:{
                    filter:JSON.stringify(filterData),
                    limit:pagination.limit,
                    page:pagination.page,
                }
            });

            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));

            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Posted Jobs ${formatDate(currentDateAndTime())}.xlsx`);
            document.body.appendChild(link);
            link.click();

            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            setLoadingFilter(false);
            toast.success("Excel Exported Successfully!");
        } catch (error) {
            console.error('Error exporting jobs:', error);
            setLoadingFilter(false);
        }
    };
    
    const handleRecruiterWiseExport = async () => {
        try {
            setLoadingFilter("3");
            const response = await axios.get(`${basePath}/getassignrecruiterlog?download=yes&id=${localStorage.getItem("userId")}&filter=${JSON.stringify(recruiterReportFilter)}`, {
                responseType: 'blob', // Ensure response is treated as a blob
                headers:apiHeaderJSON
            });
            
            // Create a URL for the blob object
            const url = window.URL.createObjectURL(new Blob([response.data]));
            
            // Create a temporary <a> element to trigger the download
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'exported_jobs.xlsx');
            document.body.appendChild(link);
            link.click();
            
            // Clean up resources
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
            setLoadingFilter(false);
        } catch (error) {
            setLoadingFilter(false);
            console.error('Error exporting jobs:', error);
        }
    };

    useEffect(() => {
        setLoading("1");
        getUserData();
        getList();
    }, []);

    const handleSubmitUpdate = (e) => {
        const errorList = validateForm();
        console.log("errorList", errorList);
        if (Object.keys(errorList).length > 0) {
            setErrors(errorList);
            return;
        }
        e.preventDefault();

        Swal.fire({
            title: 'Are you sure?',
            text: `You want to Update the Job!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Update!',
            cancelButtonText: 'No, Cancel!',
            confirmButtonColor: '#1F1E30',
            cancelButtonColor: '#F44336',
            allowOutsideClick: false,
        }).then(async (result) => {
            if (!result.isConfirmed) return;
            setLoading("2");
            let config = {};
            let requestData;

            const hasFile = formData?.jd_upload instanceof File;

            if (hasFile) {
                requestData = {
                    ...formData,
                    company_id: formData?.company,
                    position: formData?.position,
                    location: formData?.location,
                    min_experience: formData?.min_experience,
                    max_experience: formData?.max_experience,
                    min_ctc: formData?.minCtc,
                    max_ctc: formData?.maxCtc,
                    min_age: formData?.min_age,
                    max_age: formData?.max_age,
                    currency_code: formData?.currency_code,
                    no_of_positions: formData?.no_of_positions,
                    positon_industry: formData?.positon_industry,
                    gender_pref: formData?.gender_pref,
                    qualification: formData?.qualification,
                    recruiter_id: localStorage.getItem("userId"),
                    extra_questions: extraQuestions,
                    jd_upload: formData?.jd_upload,
                };

                config = {
                    headers: formData?.jd_upload ? apiHeaderFile : apiHeaderJSON,
                };

            } else {
                // Use application/json
                requestData = {
                    ...formData,
                    company_id: formData?.company,
                    position: formData?.position,
                    location: formData?.location,
                    min_experience: formData?.min_experience,
                    max_experience: formData?.max_experience,
                    min_ctc: formData?.minCtc,
                    max_ctc: formData?.maxCtc,
                    min_age: formData?.min_age,
                    max_age: formData?.max_age,
                    currency_code: formData?.currency_code,
                    no_of_positions: formData?.no_of_positions,
                    positon_industry: formData?.positon_industry,
                    gender_pref: formData?.gender_pref,
                    qualification: formData?.qualification,
                    recruiter_id: localStorage.getItem("userId"),
                    extra_questions: extraQuestions,
                    jd_upload: null
                };

                config = {
                    headers: apiHeaderJSON,
                };
            }

            try {
                const response = await axios.patch(`${basePath}/updatejob/${formData?.id}`, requestData, config);
                // console.log("/updatejob - response", response);
                if (response.status === 200) {
                    handleClose();
                    getList();
                    toast.success(response.data?.message || "Job Updated Successfully");
                } else {
                    toast.error(response.data?.message || "Unable to update job");
                }
                setLoading(false);
            } catch (error) {
                setLoading(false);
                if (error.response) {
                    console.error("Job update Response error:", error.response.status, error.response.data);
                    toast.error(error.response.data.message || "Failed to update job");
                } else {
                    // Network or other error
                    console.error("update Request error:", error.message);
                    toast.error("Network or unexpected error occurred.");
                }
            }

        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errorList = validateForm();
        console.log("errorList", errorList);
        if (Object.keys(errorList).length > 0) {
            setErrors(errorList);
            return;
        }

        Swal.fire({
            title: 'Are you sure?',
            text: `You want to Submit!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Submit!',
            cancelButtonText: 'No, Cancel!',
            confirmButtonColor: '#1F1E30',
            cancelButtonColor: '#F44336',
            allowOutsideClick: false,
        }).then(async (result) => {
            if (!result.isConfirmed) return;
            setLoading("2");

            let config = {};
            let requestData;

            const hasFile = formData?.jd_upload instanceof File;

            if (hasFile) {
                requestData = {
                    company_id: formData?.company,
                    position: formData?.position,
                    location: formData?.location,
                    min_experience: formData?.min_experience,
                    max_experience: formData?.max_experience,
                    min_ctc: formData?.minCtc,
                    max_ctc: formData?.maxCtc,
                    currency_code: formData?.currency_code,
                    no_of_positions: formData?.no_of_positions,
                    positon_industry: formData?.positon_industry,
                    gender_pref: formData?.gender_pref,
                    qualification: formData?.qualification,
                    recruiter_id: localStorage.getItem("userId"),
                    extra_questions: extraQuestions,
                    jd_upload: null
                };
                if (isObject(formData?.jd_upload)) {
                    requestData.jd_upload = formData.jd_upload;
                }

                config = {
                    headers: apiHeaderFile,
                };

            } else {
                // Use application/json
                requestData = {
                    company_id: formData?.company,
                    position: formData?.position,
                    location: formData?.location,
                    min_experience: formData?.min_experience,
                    max_experience: formData?.max_experience,
                    min_ctc: formData?.minCtc,
                    max_ctc: formData?.maxCtc,
                    currency_code: formData?.currency_code,
                    no_of_positions: formData?.no_of_positions,
                    positon_industry: formData?.positon_industry,
                    gender_pref: formData?.gender_pref,
                    qualification: formData?.qualification,
                    recruiter_id: localStorage.getItem("userId"),
                    extra_questions: extraQuestions,
                    jd_upload: null
                };

                config = {
                    headers: apiHeaderJSON,
                };
            }

            try {
            const response = await axios.post(`${basePath}/job`, requestData, config);
            // console.log("/job - response", response);
            if (response.status === 200) {
                handleClose()
                getList();
                toast.success(response.data?.message || "Job Posted Successfully");
            } else {
                toast.error(response.data?.message || "Unable to post job");
            }
            setLoading(false);
        } catch (error) {
                setLoading(false);
                if (error.response) {
                    console.error("Job post Response error:", error.response.status, error.response.data);
                    toast.error(error.response?.error || error.response?.data?.message || "Failed to post job");
                } else {
                    // Network or other error
                    console.error("Request error:", error.message);
                    toast.error("Network or unexpected error occurred.");
                }
            }
        });
    };

    const validateFormAssignRecruiter = ()=>{
        const errors = {};
        if (!formData?.recruiter_id) {
            errors.recruiter_id = "Recruiter is required!";
            return errors;
        }
        if (!formData?.assign_date) {
            errors.assign_date = "Assign date is required!";
            return errors;
        }
        return errors;
    }

    const validateForm = ()=>{
        const errors = {};

        if (!formData?.company) {
            errors.company = "Company is required";
            return errors;
        }
        if (!formData?.position || formData?.position.trim() === "") {
            errors.position = "Position is required";
            return errors;
        } else if (formData?.position.length < 3) {
            errors.position = "Position must be at least 3 characters";
            return errors;
        }
        if (!formData?.location || formData?.location.trim() === "") {
            errors.location = "Location is required";
            return errors;
        } else if (formData?.location.length < 3) {
            errors.location = "Location must be at least 3 characters";
            return errors;
        } else if (!/^[a-zA-Z\s]+$/.test(formData?.location)) {
            errors.location = "Location can only contain letters";
            return errors;
        }
        if (!formData?.min_experience || formData?.min_experience.trim() === "") {
            errors.min_experience = "Min Experience is required";
            return errors;
        } else if (!validateNumber(formData?.min_experience, 50)?.success) {
            errors.min_experience = validateNumber(formData?.min_experience, 50)?.message;
            return errors;
        }
        if (!formData?.max_experience || formData?.max_experience.trim() === "") {
            errors.max_experience = "Max Experience is required";
            return errors;
        } else if (!validateNumber(formData?.max_experience, 50)?.success) {
            errors.max_experience = validateNumber(formData?.max_experience, 50)?.message;
            return errors;
        }
        if (!formData?.currency_code) {
            errors.currency_code = "Currency is required";
            return errors;
        }  
        if (!formData?.minCtc || formData?.minCtc.trim() === "") {
            errors.minCtc = "Min CTC is required";
            return errors;
        } else if (!validateNumber(formData?.minCtc, 100000000)?.success) {
            errors.minCtc = validateNumber(formData?.minCtc, 50)?.message;
            return errors;
        }
        if (!formData?.maxCtc || formData?.maxCtc.trim() === "") {
            errors.maxCtc = "Max CTC is required";
            return errors;
        } else if (!validateNumber(formData?.maxCtc, 100000000)?.success) {
            errors.maxCtc = validateNumber(formData?.maxCtc, 50)?.message;
            return errors;
        }
        if (!formData?.no_of_positions || formData?.no_of_positions.trim() === "") {
            errors.no_of_positions = "No. of Position is required";
            return errors;
        } else if (!validateNumber(formData?.no_of_positions, 2000)?.success) {
            errors.no_of_positions = validateNumber(formData?.no_of_positions, 50)?.message;
            return errors;
        }
        if (!formData?.positon_industry || formData?.positon_industry.trim() === "") {
            errors.positon_industry = "Industry is required";
            return errors;

        }else if (!/^[a-zA-Z\s]+$/.test(formData?.positon_industry)) {
            errors.positon_industry = "Industry can only contain letters";
            return errors;
        }

        if (!formData?.gender_pref) {
            errors.gender_pref = "Gender is required";
            return errors;
        }
        if (!formData?.qualification || formData?.qualification.trim() === "") {
            errors.qualification = "Qualification is required";
            return errors;
        }
        if (formData?.min_age && !validateNumber(formData?.min_age, 60)?.success) {
            errors.min_age = `${validateNumber(formData?.min_age, 60)?.message}`;
            return errors;
        } 
        else if (formData?.min_age && validateNumber(formData?.min_age, 60)?.success && parseInt(formData?.min_age) < 18){
            errors.min_age = `Minimum age should be 18!`;
            return errors;
        }
        if (formData?.max_age && !validateNumber(formData?.max_age, 60)?.success) {
            errors.max_age = `${validateNumber(formData?.max_age, 60)?.message}`;
            return errors;
        }

        if (formData?.jd_upload && isObject(formData?.jd_upload)){
            const valid = validateFile(formData?.jd_upload, 5, ['application/pdf']);
            if (!valid?.valid) {
                errors.jd_upload = valid?.message;
                return errors;
            }
        }
       
        return errors;
    }

    const handleFollowupSubmit = async (e) => {
        e.preventDefault();
        const errorList = validateFollowupForm();
        console.log("errorList", errorList);
        if (Object.keys(errorList).length > 0) {
            setErrors(errorList);
            return;
        }

        Swal.fire({
            title: 'Are you sure?',
            text: `You want to Submit!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Submit!',
            cancelButtonText: 'No, Cancel!',
            confirmButtonColor: '#1F1E30',
            cancelButtonColor: '#F44336',
            allowOutsideClick: false,
        }).then(async (result) => {
            if (!result.isConfirmed) return;
            setLoading("3");
             
            let requestData = {
                position_id: followupData?.position_id,
                last_follow_up_date : followupData?.last_followup_date,
                remarks: followupData?.followup_remarks
            };

            let config = {
                headers: apiHeaderJSON,
            };

            try {
            const response = await axios.post(`${basePath}/UpdateFollowUpDate`, requestData, config);
            // console.log("/job - response", response);
            if (response.status === 200) {
                handleClose();
                getList();
                toast.success(response.data?.message || "Follow Up date updated Successfully");
            } else {
                toast.error(response.data?.message || "Unable to update follow Up date.");
            }
            setLoading(false);
            } catch (error) {
                if (error.response) {
                    console.error("Follow Up date update Response error:", error.response.status, error.response.data);
                    toast.error(error.response.data?.message || "Unable to update follow Up date.");
                } else {
                    // Network or other error
                    console.error("Request error:", error.message);
                    toast.error("Network or unexpected error occurred.");
                }
                setLoading(false);
            }
        });
    };

    const getFollowUpHistory = async (val) => {

        setLoading("4");
        try {
            let options = {
                params:{
                    position_id:val?.id
                },
                headers:apiHeaderJSON
            }
            let response = await axios.get(`${basePath}/GetFollowUpLogs`, options);

            setViewFollowUpLogs(response.data.log_data);
            setLoading(false);

        } catch (error) {
            setLoading(false);
            if (error.response) {
                console.error("error:", error.response.status, error.response.data);
                toast.error(error.response.data?.message || "Failed to get logs");
            } else {
                // Network or other error
                console.error("Request error:", error.message);
                toast.error("Network or unexpected error occurred.");
            }
        }
    }


    const validateFollowupForm = ()=>{
        const errors = {};

       if (!followupData?.last_followup_date) {
            errors.last_followup_date = "Last followup date is required";
            return errors;
        }     
       
        return errors;
    }
    
    const handleView = (val) => {
        setFormData({
            id: val?.id,
            company: val?.company_id,
            position: val?.position,
            location: val?.location,
            min_experience: val?.min_experience,
            max_experience: val?.max_experience,
            currency_code: val?.currency_code,
            minCtc: val?.min_ctc,
            maxCtc: val?.max_ctc,
            min_age: val?.min_age,
            max_age: val?.max_age,
            no_of_positions: val?.no_of_positions,
            positon_industry: val?.positon_industry,
            gender_pref: val?.gender_pref,
            qualification: val?.qualification,
            description: val?.jd_upload,
            jd_upload: val?.jd_link
        });
         const mappedQuestions = val?.PositionQuestions?.map(q => ({
            question_id: q.question_id,           
            question: q.question_text || "",
            required: q.is_mandatory == 1,        
            type: "text",                     
        }));
        setExtraQuestions(mappedQuestions);
        setJobFormModal(val);
    }
    const handleCancel = ()=> {
        setFormData({
            id: jobFormModal?.id,
            company: jobFormModal?.company_id,
            position: jobFormModal?.position,
            location: jobFormModal?.location,
            min_experience: jobFormModal?.min_experience,
            max_experience: jobFormModal?.max_experience,
            min_age: jobFormModal?.min_age,
            max_age: jobFormModal?.max_age,
            minCtc: jobFormModal?.min_ctc,
            currency_code: jobFormModal?.currency_code,
            maxCtc: jobFormModal?.max_ctc,
            no_of_positions: jobFormModal?.no_of_positions,
            positon_industry: jobFormModal?.positon_industry,
            gender_pref: jobFormModal?.gender_pref,
            qualification: jobFormModal?.qualification,
            description: jobFormModal?.jd_upload,
            jd_upload: jobFormModal?.jd_link,
        });
        const mappedQuestions = jobFormModal?.PositionQuestions?.map(q => ({
            question_id: q.question_id,           
            question: q.question_text || "",
            required: q.is_mandatory == 1,        
            type: "text",                     
        }));
        setExtraQuestions(mappedQuestions);
        setJobEdit(false);
    }
    const handleNewJob = ()=> {
        setFormData({});
        setJobEdit(true);
        setJobFormModal(true);
    }
    const handleDelete = (e, id) => {
        Swal.fire({
        title: 'Are you sure?',
        text: `You want to delete? You won't be able to revert this.`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, Delete!',
        cancelButtonText: 'No, Cancel!',
        confirmButtonColor: '#1F1E30', 
        cancelButtonColor: '#F44336',
        allowOutsideClick:false,
        }).then((result) => {
            if (result.isConfirmed) {
            setLoading(true);
            const options = {
                url: `${basePath}/deletejob/${id}`,
                method: "DELETE",
                headers: {
                    Accept: "application/json",
                },
            }
            axios(options)
            .then((response) => {
                if (response.status == 200) {
                    setLoading(false);
                    getList();
                    toast.success("Job Deleted Successfully");
                    // console.log("Information Deleted successfully");
                }
                else {
                    setLoading(false);
                    toast.error(response?.data?.message ||"Unable to delete job.");
                }
            })
            .catch((error) => {
                setLoading(false);
                    const errorMsg = error?.response?.data?.message || 
                    error?.response?.data?.error || "Unable to delete job.";
                toast.error(errorMsg|| "Unable to delete job.");
            });
        }})
    }
    const handleClose = ()=> {
        setRecruiterModal(false);
        setRecruiterReportFilter({fromDate: "", toDate: "",
            company: "", position: "", orderBy: "assigned_at", recruiter: "",
            recruiterStatus: 1, isActive: true, orderDirection: "DESC",
            status: "",});
        if (recruiterWiseView){
            const all = allUsers?.filter((val)=>{if(val?.activated === 1) return val;});
            setUsersOption([
                {value: "Only Assigned", label: "Assigned"},
            {value: "Not Assigned", label: "Not Assigned"}, ...all]);
        }
        setRecruiterWiseView(false)
        setPaginationRecruiterWiseList({page: 1, totalRecords: "", totalPages: "", limit: 10,})
        setFormData({});
        setFollowupData({});
        setViewFollowUpLogs(false);
        setErrors({});
        setJobEdit(false);
        setExtraQuestions([]);
        setJobFormModal(false);
        setFollowupModal(false);
    }
    const handleFilter = useCallback(()=>{ 
        setLoadingFilter("1"); 
        getList();
    },[getList]);

    const handleClear = useCallback(()=> {
        setLoadingFilter("2");
        setFilterData({
            fromDate: "",
            toDate: "",
            company: "",
            position: "",
            positionStatus: "",
            orderBy: "",
            orderDirection: "",
        });
        const all = allUsers?.filter((val)=>{
            if(val?.activated === 1) return val;
        });
        setUsersOption([{value: "Only Assigned", label: "Assigned"},
            {value: "Not Assigned", label: "Not Assigned"}, ...all]);
        setIschanged({...ischanged, getListChanged:true})
    },[ischanged]);

    const handleRecruiterWiseClear = ()=> {
        setLoadingFilter("2")
        setRecruiterReportFilter({fromDate: "", toDate: "",
            company: "", position: "",
            recruiter: "", isActive: true,
            positionStatus: "",
            orderBy: "assigned_at",
            orderDirection: "DESC"
        });
        const all = allUsers?.filter((val)=> {
            if(val?.activated === 1) return val;
        });
        setUsersOption([{value: "Only Assigned", label: "Assigned"},
            {value: "Not Assigned", label: "Not Assigned"}, ...all]);
        setIschanged({...ischanged, getRecruiterWiseDataChanged: true});
    }

    const handleSort = (e) => {
        const {id} = e.currentTarget;
        // console.log("id", id);
        if (recruiterReportFilter?.orderBy === id) {
            if (recruiterReportFilter?.orderDirection === "DESC") {
                setRecruiterReportFilter({ ...recruiterReportFilter, orderBy: id, orderDirection: 'ASC' });
            }
            else {
                setRecruiterReportFilter({ ...recruiterReportFilter, orderBy: id, orderDirection: 'DESC' });
            }
        }
        else {
            setRecruiterReportFilter({ ...recruiterReportFilter, orderBy: id, orderDirection: 'ASC' });
        }
        setIschanged({ ...ischanged, getRecruiterWiseDataChanged: true });
    }

    const handleRecruiterWiseSelect = (value)=> {
        setFilterData({
            ...filterData,
            company: value?.Position?.Company?.company_name,
            position: value?.Position?.position,
            fromDate: "",
            toDate: "",
            candidate: "",
            orderBy: "sourcing_date",
            orderDirection: "DESC"
        });
        handleClose()
        setIschanged({ ...ischanged, getListChanged: true });
    }
    const handleRecruiterWiseCheck = useCallback((event)=> {
        //  console.log("event.target",event.target);
        const {checked } = event?.target;
        // console.log(checked);
        const num = !checked ? 2 : 1;
        // console.log("allUsers",allUsers);
        const all = allUsers?.filter((val)=>{if(val?.activated === num) return val;});
        setRecruiterReportFilter({ ...recruiterReportFilter, isActive: checked }); 
        setUsersOption([
            {value: "Only Assigned", label: "Assigned"},
            {value: "Not Assigned", label: "Not Assigned"},
            ...all]);
    },[allUsers, recruiterReportFilter]);
    const handleRecruiterReportModal = ()=> {
        setRecruiterReportFilter({fromDate: "", toDate: "",
            company: "", position: "", orderBy: "assigned_at", recruiter: "",
            recruiterStatus: 1, isActive: true, orderDirection: "DESC",
            status: "",
        });
        setRecruiterWiseView(true);
        setIschanged({...ischanged, getRecruiterWiseDataChanged: true});
    }

    const handleRecruiterWiseRefresh = ()=> {
        setLoading("5");
        getRecruiterWiseData();
    }   

    const handleChangeRecruiterWiseFilter = useCallback((event)=> {
        const {name, value} = event?.target;
            console.log("name, value",name, value);
        setRecruiterReportFilter({ ...recruiterReportFilter, [name]: value, });
    },[recruiterReportFilter]);

    const handleRecruiterWiseFilter = ()=> {
        setLoadingFilter("1");
        getRecruiterWiseData();
    }

    const bgColors = [
    'bg-blue-900', 'bg-amber-900',
    'bg-yellow-500', 'bg-purple-500', 'bg-pink-500',
    'bg-indigo-500', 'bg-rose-500', 'bg-teal-500'
    ];
    // used for debounce timer 
    const debounceTimerRef = useRef(null);
    const debounceList = (delay = 500)=> {
        // it will call getList after defined time (delay)
        if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
        }
        debounceTimerRef.current = setTimeout(() => {
            setIschanged({ ...ischanged, getListChanged: true })
        }, delay);
    }
    const handleChange = useCallback((event)=> {
        const {name, value} = event?.target;
        // console.log("name, value", name, value);
        setFormData({ ...formData, [name]: value, });  
        setErrors({ ...errors, [name]: "", });  
    },[formData, errors]);

    const handleFollowupChange = useCallback((event)=> {
        const {name, value} = event?.target;
        // console.log("name, value", name, value);
        setFollowupData({ ...followupData, [name]: value, });
        setErrors({ ...errors, [name]: "", });   
    },[followupData, errors]);

    const handleChangeFilter = useCallback((event)=> {
        const {name, value} = event?.target;
        // console.log("name, value", name, value);
        setFilterData({ ...filterData, [name]: value, });
        // it will call getList after defined time (delay)
        // debounceList();        
    },[filterData]);

    const handleLimit = (e)=> {
        setPagination({...pagination, limit: e.target.value});
        setIschanged({...ischanged, getListChanged: true})
    }
    const handlePrev = (e)=> {
        if (pagination?.page > 1) {
            setPagination({...pagination, page: pagination?.page - 1});
            setIschanged({...ischanged, getListChanged: true})
        }
    }
    const handleNext = (e)=> {
        if (pagination?.totalPages > pagination?.page) {
            setPagination({...pagination, page: pagination?.page + 1});
            setIschanged({...ischanged, getListChanged: true});
        }
    }

    const handleCheck = useCallback((event)=> {
        //  console.log("event.target",event.target);
        const {checked } = event?.target;
        // console.log(checked);
        const num = !checked ? 2 : 1;
        // console.log("allUsers",allUsers);
        const all = allUsers?.filter((val)=>{if(val?.activated === num) return val;});
        setFilterData({ ...filterData, isActive: checked }); 
        setUsersOption([
            {value: "Only Assigned", label: "Assigned"},
            {value: "Not Assigned", label: "Not Assigned"},
            ...all]);
    },[allUsers, filterData]);

    const handleRecruiterWiseLimit = (e)=> {
        setPaginationRecruiterWiseList({...paginationRecruiterWiseList, limit: e.target.value});
        setIschanged({...ischanged, getRecruiterWiseDataChanged: true});
    }
    const handleRecruiterWisePrev = ()=> {
        if (pagination?.page > 1) {
            setPaginationRecruiterWiseList({...paginationRecruiterWiseList, page: pagination?.page - 1});
            setIschanged({...ischanged, getRecruiterWiseDataChanged: true});
        }
    }
    const handleRecruiterWiseNext = ()=> {
        if (pagination?.totalPages > pagination?.page) {
            setPaginationRecruiterWiseList({...paginationRecruiterWiseList, page: pagination?.page + 1});
            setIschanged({...ischanged, getRecruiterWiseDataChanged: true});
        }
    }

    const handleAddQuestion = (e)=>{
        const add = [...extraQuestions, {type: "text", question: "", required: false}]
        setExtraQuestions(add);
    }

    const handleDeleteQuestion = (e) => {
        const index = Number(e.currentTarget.dataset.index);
        const arr = [...extraQuestions];
        arr.splice(index, 1);
        setExtraQuestions(arr);
    };

    const handleChangeQuestion = (e) => {
        const {index, name, value} = e.target;
        // console.log("index, name, value",index, name, value);
        const updatedRows = [...extraQuestions];
        updatedRows[index] = {
            ...updatedRows[index],
            [name]: value,
        };
        setExtraQuestions(updatedRows);
    };
    const handleEdit = (val)=> {
        setJobEdit(true);
    }
    
    const handleFollowUp = (val)=> {
        setFollowupModal(!followupModal);
        setFollowupData({
            position: val?.position,
            company_name: val?.Company?.company_name,
            prevDate: val?.last_follow_up_date,
            position_id: val?.id,
            last_followup_date: val?.last_follow_up_date,
            upcoming_followup_date: val?.next_follow_up_date,
            prevRemark: val?.remarks,
            followup_remarks: val?.remarks,
        })
    };

    const handleActiveCv = (val)=> {
        // console.log("val?.active_cv_count => OUT",val?.active_cv_count);
        if (val?.active_cv_count > 0 || val?.total_sent_cvs > 0) {
            // console.log("val?.active_cv_count => IN",val?.active_cv_count);
            navigate(`/ats-pipeline/${atsIndex}?position=${val?.position}&company=${val?.Company.company_name}`);
        }
    }
    const handleJoinedCv = (val)=> {
        if (val?.joined_count > 0) {
            navigate(`/ats-pipeline/${atsIndex}?position=${val?.position}&company=${val?.Company.company_name}`);
        }
    }
    
    return (
        <section onClick={() => { setIsModalOpen(false); }} className='lightBabyGreen baseHeightWidth customScroll mb-5'>
            {/* RefreshButton => used for refresh table data */}
            <RefreshButton onClick={handleRefresh} position='fixed' />
            <div>
                {/* PageBanner => used to show page banner info */}
                <PageBanner pageName='All Posted Jobs' pageTitle='Stay on top of every hiring move.' src='/img/registration.png' alt="all jobs" />
                {recruiterModal && (
                    <RecruiterAssigning 
                    formData={formData}
                    options={usersOption}
                    loading={loading === "3"}
                    errors={errors}
                    onAssignDate={handleAssignDate}
                    onClose={handleClose}
                    onChange={handleChange}
                    onSubmit={handleRecruiter}
                    />
                )}
                {recruiterWiseView &&
                    <RecruiterWiseData
                    rows={recruiterWiseData}
                    filterData={recruiterReportFilter}
                    pagination={paginationRecruiterWiseList}
                    loading={loading === "4"}
                    loadingFilter={loadingFilter}
                    usersOption={usersOption}
                    onRefresh={handleRecruiterWiseRefresh}
                    onClose={handleClose}
                    onFilterChange={handleChangeRecruiterWiseFilter}
                    onFilter={handleRecruiterWiseFilter}
                    onClear={handleRecruiterWiseClear}
                    onExport={handleRecruiterWiseExport}
                    onSort={handleSort}
                    onRecruiterWiseDataSelect={handleRecruiterWiseSelect}
                    onCheck={handleRecruiterWiseCheck}
                    onLimit={handleRecruiterWiseLimit}
                    onPrev={handleRecruiterWisePrev}
                    onNext={handleRecruiterWiseNext}
                    />
                }
                {jobFormModal && (
                    <JobPost 
                    data={formData} 
                    disabled={!jobEdit} 
                    onChange={handleChange} 
                    onCancel={handleCancel}
                    onClose={handleClose} 
                    onEdit={handleEdit}
                    onSubmit={handleSubmit} 
                    onlyView={!user[index]?.edit_access}
                    onAddQuestions={handleAddQuestion} 
                    extraQuestions={extraQuestions} 
                    onDeleteQuestion={handleDeleteQuestion}
                    onChangeQuestions={handleChangeQuestion} 
                    errors={errors} 
                    handleSubmitUpdate = {handleSubmitUpdate} 
                    loading={loading === "2"} 
                    />                   
                )}
                {followupModal && (
                    <FollowUp 
                    data={followupData}
                    onChange={handleFollowupChange} 
                    loading={loading === "3"}
                    onSubmit={handleFollowupSubmit} 
                    onClose={handleClose}
                    />
                )}
                {viewFollowUpLogs && (
                    <PositionFollowUpHistory
                    loading={loading}
                    data={viewFollowUpLogs}
                    onClose={handleClose}
                    />
                )}
                {/* Filters */}
                <div className=' grid lg:grid-cols-5 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 items-center gap-3 grayBlurShadow bg-white p-3 mt-5 rounded-xl'>
                    {user[index]?.add_access &&
                    (<div onClick={handleNewJob} className='darkPurple my-2 mx-auto w-full cursor-pointer rounded-full py-2 px-3 text-white flex items-center gap-2 font-bold grayBlurShadow hoverGreen navAnimation'>
                        <IoMdAddCircleOutline className=' text-4xl text-white' />
                        <button>Post New Job</button>
                    </div>)}
                    <InputField  id="fromDate" name="fromDate" type="date" label="From Date:"
                    disabled={loading === '1'}
                    value={filterData?.formData}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="toDate" name="toDate" type="date" label="To Date:"
                    disabled={loading === '1'}
                    value={filterData?.toDate}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="company" name="company" type="text" label="Company:"
                    placeholder="Enter Company"
                    disabled={loading === '1'}
                    value={filterData?.company}
                    onChange={handleChangeFilter}
                    />
                    <InputField  id="position" name="position" type="text" label="Position:"
                    placeholder="Enter Position"
                    disabled={loading === '1'}
                    value={filterData?.position}
                    onChange={handleChangeFilter}
                    />
                    {/* {localStorage.getItem("role") === "Recruiter" || localStorage.getItem("role") === "Team Lead" ?
                        null :
                        <Dropdown id="recruiterId" name="recruiterId" label="Recruiter:"
                        onChange={handleChangeFilter}
                        className=" rounded border border-gray-300 w-full text-[0.8rem]"
                        placeholder={`Select Recruiter`}
                        value={filterData?.recruiterId}
                        options={allUsers}
                        search={true}
                    />
                    } */}
                    {localStorage.getItem("role") === "Recruiter" ? null :
                        <Dropdown id="recruiterId" name="recruiterId" label="Recruiter:"
                            onChange={handleChangeFilter}
                            className=" rounded border border-gray-300 w-full text-[0.8rem]"
                            placeholder={`Select Recruiter`}
                            value={filterData?.recruiterId}
                            options={usersOption}
                            search={true} // to enable search input
                            checkBox={true} // to enable checkbox
                            checkValue={filterData?.isActive} // to make checkbox check and uncheck
                            onCheck={handleCheck} // to make changes in list of options onChange
                        />
                    }
                    <Dropdown id="positionStatus" name="positionStatus"
                        onChange={handleChangeFilter}
                        onCancel={handleChangeFilter}
                        label="Job Status:"
                        className={`rounded border bg-white border-gray-300 w-full flex-1 text-[0.8rem]`}
                        placeholder={`All`}
                        value={filterData?.positionStatus}
                        options={jobStatusOptions}
                    />
                    <div className="flex gap-3 col-span-1">
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Apply Filter</label>
                            <BasicButton onClick={handleFilter} buttonName='Apply Filter' className='darkPurple text-nowrap' shadow={true}
                            disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.company && !filterData?.position && !filterData?.recruiterId && !filterData?.positionStatus)} 
                            loading={loadingFilter === "1"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hoverGreen" />
                        </div>
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Clear Filter</label>
                            <BasicButton onClick={handleClear} buttonName='Clear Filter' className="bg-red-600 text-nowrap" shadow={true}
                            disabled={loading || loadingFilter || (!filterData?.fromDate && !filterData?.toDate && !filterData?.company && !filterData?.position && !filterData?.recruiterId && !filterData?.positionStatus)} 
                            loading={loadingFilter === "2"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-red-900" />
                        </div>
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Excel Export</label>
                            <BasicButton onClick={handleExport} buttonName='Excel' className="bg-green-800 text-nowrap" shadow={true}
                            disabled={loading || loadingFilter || allJobs.length === 0} 
                            loading={loadingFilter === "3"} loadingMessage="Loading" rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-green-950" />
                        </div>
                        <div className=" flex flex-col">
                            <label className="block  text-left font-medium text-gray-700 mb-1 text-nowrap">Recruiter Details</label>
                            <BasicButton onClick={handleRecruiterReportModal} buttonName='Recruiter Details' className="bg-purple-700 text-nowrap" shadow={true}
                            disabled={loading} 
                            rounded="lg" textAlign="center" fontWeight="bold" onHover="hover:bg-purple-900" />
                        </div>
                    </div>
                </div>
                {loading === "1" ?
                    <Loader/> :
                    Array.isArray(allJobs) && allJobs.length >= 1 ?
                        <section className='tableWrapper'>
                            <div className='tableBody'>
                                <table className='w-full table-fixed border-collapse'>
                                    <thead className='tableHead'>
                                        <tr className=' text-left'>
                                            <th className='whitespace-nowrap text-center w-[14%]'>
                                                <div onClick={() => handleJobSort("upload_date")} className='flex item-center gap-2 pr-2 justify-center w-full cursor-pointer'>
                                                    Posted Date
                                                    {filterData?.orderBy === "upload_date" && filterData?.orderDirection === "ASC" ?
                                                        <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                        filterData?.orderBy === "upload_date" && filterData?.orderDirection === "DESC" ?
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                                </div>
                                            </th> 
                                            <th>
                                                <div onClick={() => handleJobSort("company")} className='flex item-center gap-2 pr-2 justify-start cursor-pointer'>
                                                    Company
                                                    {filterData?.orderBy === "company" && filterData?.orderDirection === "ASC" ?
                                                        <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                        filterData?.orderBy === "company" && filterData?.orderDirection === "DESC" ?
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                                </div>
                                            </th>
                                            <th className='w-[12%]'>
                                                <div onClick={() => handleJobSort("max_ctc")} className='flex item-center gap-2 pr-2 justify-center w-full cursor-pointer'>
                                                   CTC
                                                    {filterData?.orderBy === "max_ctc" && filterData?.orderDirection === "ASC" ?
                                                        <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                        filterData?.orderBy === "max_ctc" && filterData?.orderDirection === "DESC" ?
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                                </div>
                                            </th>
                                            <th className=' text-center'>CVs / Pos.</th>
                                            <th className=' text-center w-[16%]'>Recruiter</th>
                                            {/* <th className=' whitespace-nowrap text-center w-[16%]'>
                                                <div onClick={() => handleJobSort("recruiter")} className='flex item-center gap-2 pr-2 justify-center w-full cursor-pointer'>
                                                    Recruiter
                                                    {filterData?.orderBy === "recruiter" && filterData?.orderDirection === "ASC" ?
                                                        <UpDownArrow upArrowColor="text-blue-900" downArrowColor="text-gray-400" /> :
                                                        filterData?.orderBy === "recruiter" && filterData?.orderDirection === "DESC" ?
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-blue-900" /> :
                                                        <UpDownArrow upArrowColor="text-gray-400" downArrowColor="text-gray-400" />}
                                                </div>
                                            </th> */}
                                            <th className='whitespace-nowrap text-center w-[12%]'>Job Status</th>
                                            <th className='whitespace-nowrap text-center w-[8%]'>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody className='tableBody '>
                                        {
                                            allJobs?.map((val) => {
                                                return (
                                                    <tr key={val?.id} id={val?.id} className=' backWhite font-semibold text-sm text-left'>
                                                        <td className='whitespace-nowrap text-center'>{val?.upload_date ? formatDate(val?.upload_date) : "--"}</td>
                                                        <td className=' whitespace-nowrap'>
                                                            <span className='line-clamp-1 text-ellipsis'>{val?.Company.company_name}</span>
                                                            <span className={`text-sm line-clamp-1 text-ellipsis ${val?.position && (user[index]?.view_access || user[index]?.edit_access) && "text-blue-900 hover:text-blue-700 hover:underline transition-all duration-150 ease-in-out cursor-pointer"}`} onClick={()=> {if (user[index]?.view_access || user[index]?.edit_access) handleView(val); }} >{val?.position}</span>
                                                        </td>
                                                        <td className=' whitespace-nowrap'><span className=' text-green-500'>{val?.currency_code}</span> {val?.max_ctc?.toString()?.padStart(2,0)} LPA</td>
                                                        <td>
                                                            <div onClick={()=> handleActiveCv(val)} className={`flex justify-center w-fit m-auto items-center gap-1 ${(val?.active_cv_count > 0 || val?.total_sent_cvs > 0)  ? "cursor-pointer" : ""}`}>
                                                                <span className={`line-clamp-1 text-ellipsis ${val?.active_cv_count > 0 ? "text-green-700 hover:text-green-500 transition-all ease-in-out duration-300" : "text-gray-400"}`}>{val?.active_cv_count} Active</span>
                                                                <span className={`line-clamp-1 text-ellipsis ${val?.total_sent_cvs > 0 ? "hover:text-gray-500 transition-all ease-in-out duration-300" : "text-gray-400"}`}> | {val?.total_sent_cvs} Total</span>
                                                            </div>
                                                            {
                                                                val?.joined_count > 0 ? (
                                                                    <div onClick={()=> handleJoinedCv(val)} className={`flex justify-center w-fit m-auto items-center gap-1 ${val?.joined_count > 0 ? "cursor-pointer" : ""}`}>
                                                                        <span className={`line-clamp-1 text-ellipsis ${val?.joined_count > 0 ? "text-green-700 hover:text-green-500 transition-all ease-in-out duration-300" : "text-gray-400"}`}>{val?.joined_count} Joined</span>
                                                                        <span className={`line-clamp-1 text-ellipsis text-blue-950`}> | {val?.no_of_positions} {val?.no_of_positions > 1 ? "Positions" : "Position"}</span>
                                                                    </div>
                                                                ) : (
                                                                    <span className={`line-clamp-1 text-ellipsis text-center text-blue-950`}>{val?.no_of_positions} {val?.no_of_positions > 1 ? "Positions" : "Position"}</span> 
                                                                )
                                                            }
                                                            
                                                        </td>
                                                        <td>
                                                            {
                                                                val?.assignRecuiters?.length >= 1 ?
                                                                    <div>
                                                                        <div className="flex -space-x-3 overflow-hidden">
                                                                            {val?.assignRecuiters?.length > 0 &&
                                                                                val?.assignRecuiters.slice(0, 6).map((item, index) => {
                                                                                    const colorClass = bgColors[index % bgColors.length];
                                                                                    return (
                                                                                    <TooltipComponent className={`${val?.assignRecuiters.length > 1 ? "" : `w-full ${user[index]?.edit_access && "max-w-[8.5dvw]"}`}`} name={item?.User?.name} key={item?.recruiter_id}>
                                                                                        <h1
                                                                                        onClick={(e) => {
                                                                                            if (user[index]?.edit_access) {
                                                                                            handleDeleteRecruiter({...val, ...item})
                                                                                            }
                                                                                        }}
                                                                                        className={`border border-white rounded-full ${val?.assignRecuiters.length > 1 ? "relative w-9 h-9" : "px-2 py-2 whitespace-nowrap w-full line-clamp-1 text-ellipsis"}  text-center text-white ${colorClass} ${
                                                                                            user[index]?.edit_access && "cursor-pointer hoverRed"
                                                                                        }`}
                                                                                        >
                                                                                            {val?.assignRecuiters.length > 1
                                                                                            ? <span className=' absolute top-[22%] left-[20%]'>{item?.User?.name?.split("")[0]}{item?.User?.name?.split(" ")[1]?.split("")[0] || ""}</span>
                                                                                            : item?.User?.name}
                                                                                        </h1>
                                                                                    </TooltipComponent>
                                                                                    );
                                                                                })}
                                                                                {val?.assignRecuiters?.length < 6 && user[index]?.edit_access && (
                                                                                <TooltipComponent name="Assign Recruiter">
                                                                                    <div
                                                                                     onClick={()=> handleAssign(val)}
                                                                                     className='relative w-9 h-9 rounded-full bg-gray-300 text-center border border-white cursor-pointer
                                                                                    hover:bg-gray-400 transition-all duration-300 ease-in-out'>
                                                                                        <span className=' absolute top-[15%] left-[15%]'>
                                                                                            <IoAdd className=' text-2xl font-bold' />
                                                                                        </span>
                                                                                    </div>
                                                                                </TooltipComponent>
                                                                                )}
                                                                        </div>
                                                                    </div> 
                                                                    :
                                                                    user[index]?.edit_access ?
                                                                    (<h1 
                                                                        onClick={()=> handleAssign(val)} 
                                                                        className='flex justify-center items-center p-2 cursor-pointer rounded-lg bg-gray-300 w-full whitespace-nowrap 
                                                                    hover:bg-gray-400 transition-all duration-300 ease-in-out'>
                                                                        <TooltipComponent className="w-full flex justify-center items-center" name="Assign Recruiter">
                                                                            <IoAdd className=' text-2xl font-bold' /> Assign
                                                                        </TooltipComponent>
                                                                    </h1>) : 
                                                                    (<div className='text-center p-2 rounded-full yellowBox w-full whitespace-nowrap '>
                                                                        Not Assigned
                                                                    </div>)
                                                            }
                                                        </td>
                                                        <td>
                                                            <Dropdown id="positionStatus" name="positionStatus"
                                                                onChange={(e) => { handlePositionStatus(e, val) }}
                                                                className={`rounded border border-gray-300 w-full flex-1 text-[0.8rem]`}
                                                                placeholder={`All`}
                                                                closeBtn={false}
                                                                value={val?.position_status}
                                                                options={jobStatusOptions}
                                                                disabled={!user[index]?.edit_access}
                                                            />
                                                        </td>
                                                        <td className=' flex justify-center items-center gap-2'>
                                                            <FollowupButton notify={val?.position_status === 'Open' ? daysDifference(val?.next_follow_up_date) : false} btnName='Other Info' disabled = {!val?.total_sent_cvs || val?.position_status != 'Open'} onClick={()=> handleFollowUp(val)} />
                                                            <HistoryButton data={val} onClick={() => getFollowUpHistory(val)} tooltipName="Follow Up History" disabled={!user[index]?.view_access} />
                                                        </td>
                                                        {/* {(user[index]?.edit_access || user[index]?.delete_access) && (
                                                            <div>
                                                                <ActionMenu id={val?.id}
                                                                    permissions={{
                                                                        view: user[index]?.view_access,
                                                                        edit: user[index]?.edit_access,
                                                                        delete: user[index]?.delete_access,
                                                                    }}
                                                                    onView={() => { handleView(val); }}
                                                                    onEdit={() => { handleView(val); }}
                                                                    onDelete={(e,id) => handleDelete(e, id)}
                                                                />
                                                            </div>
                                                        )} */}
                                                    </tr>
                                                )
                                            })

                                        }
                                    </tbody>
                                </table>
                            </div>
                            <Pagination onLimitChange={handleLimit} onPrevChange={handlePrev} onNextChange={handleNext}
                            limit={pagination?.limit} totalRecords={pagination?.totalRecords} allPages={pagination?.totalPages} page={pagination?.page}
                            disabledPrev={pagination?.page === 1} disabledNext={pagination?.page === pagination?.totalPages}
                            />
                        </section> :
                        <NoRecords />
                }
            </div >
        </section >
    );
}

export default AllPostedJobs;